import Vue from "vue";
import App from "./App.vue";
import axios from "axios";
import http from "@/utils/http-common";
import router from "./router";
import store from "./store";
if (window.Cypress) window.$store = store;
import vuetify from "./plugins/vuetify";
import i18n from "./i18n";
import 'animate.css';
import fadeInOnView from './directives/fadeInOnView';
Vue.directive('fade-in-on-view', fadeInOnView);
import ellipsisTooltip from './directives/ellipsisTooltip';
Vue.directive('ellipsis-tooltip', ellipsisTooltip);

import _ from 'lodash';
Vue.prototype.$lodash = _;

import dayjs from "dayjs"
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import isYesterday from "dayjs/plugin/isYesterday";
import relativeTime from "dayjs/plugin/relativeTime";
import "dayjs/locale/ko";
dayjs.extend(isSameOrBefore);
dayjs.extend(isYesterday);
dayjs.extend(relativeTime);
dayjs.locale("ko");

import DataIcon from "@/components/DataIcon.vue"
Vue.component('DataIcon', DataIcon)
import TimelineIcon from "@/components/TimelineIcon.vue"
Vue.component('TimelineIcon', TimelineIcon)
import ProcessIcon from "@/components/ProcessIcon.vue"
Vue.component('ProcessIcon', ProcessIcon)
import DataName from "@/components/DataName.vue"
Vue.component('DataName', DataName)
import DataNameInDataList from "@/components/DataNameInDataList.vue"
Vue.component('DataNameInDataList', DataNameInDataList)
import DataChip from "@/components/DataChip.vue"
Vue.component('DataChip', DataChip)
import DataChip2 from "@/components/DataChip2.vue"
Vue.component('DataChip2', DataChip2)
import TableTitle from "@/components/TableTitle.vue"
Vue.component('TableTitle', TableTitle)
import TextInput from "@/components/TextInput.vue"
Vue.component('TextInput', TextInput)
import TextInputArea from "@/components/TextInputArea.vue"
Vue.component('TextInputArea', TextInputArea)
import TableTabList from "@/components/TableTabList.vue"
Vue.component('TableTabList', TableTabList)

import ToggleButton from 'vue-js-toggle-button'
Vue.use(ToggleButton)

import VueVirtualScroller from "vue-virtual-scroller";
import "vue-virtual-scroller/dist/vue-virtual-scroller.css";
Vue.use(VueVirtualScroller);

import VueBlobJsonCsv from "vue-blob-json-csv";
Vue.use(VueBlobJsonCsv);

import VueApexCharts from "vue-apexcharts";
Vue.use(VueApexCharts);
Vue.component("apexchart", VueApexCharts);

import lineClamp from "vue-line-clamp";
Vue.use(lineClamp);

import Carousel3d from 'vue-carousel-3d';
Vue.use(Carousel3d);

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
Vue.use(VueAwesomeSwiper)

import VueMarqueeSlider from 'vue-marquee-slider';
Vue.use(VueMarqueeSlider);

import VueTypedJs from 'vue-typed-js'
Vue.use(VueTypedJs)

import VueGtag from "vue-gtag";
if (process.env.NODE_ENV === "production") {
  Vue.use(
    VueGtag,
    {
      config: {
        id: process.env.VUE_APP_GA_ID,
        params: {
          send_page_view: false,
        },
      },
    },
    router
  );
} else {
  Vue.use(
    VueGtag,
    {
      config: {
        id: process.env.VUE_APP_GA_ID,
        params: {
          send_page_view: false,
        },
      },
    },
    router
  );
}

import * as Sentry from "@sentry/vue";
import { Integrations } from '@sentry/tracing';
if (process.env.NODE_ENV === "development") {
  Sentry.init({
    Vue,
    environment: "development",
    // release: process.env.VUE_APP_VERSION,
    release: '2025.04.17.09.46',
    dsn: "https://2b292eeafd04416a9905bd6afc1d687e@o1115955.ingest.sentry.io/4504137838952448",
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 1.0,
  });
} else if (process.env.NODE_ENV === "production") {
  Sentry.init({
    Vue,
    environment: "production",
    // release: process.env.VUE_APP_VERSION,
    release: '2025.04.17.09.46',
    dsn: "https://ca42cebcefc74e179bb5a387e43aa5b9@o1115955.ingest.sentry.io/4504137916153856",
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 1.0,
  });
}

import ChannelService from "@/utils/channel-service";
ChannelService.loadScript();

import './plugins/chartjs';

// methodRecall, transpose ...
Vue.mixin({
  methods: {
    methodRecall() { // main.js, mutations.js, index.js(router) 공유
      return new Promise((resolve, reject) => {
        // BE에 access token 저장 후 Promise 객체 return (이전 method 재호출을 위해)
        if (!store.state.isMethodRecalling) {
          // methodRecall이 호출되고 새로운 token을 갱신 및 저장 중인 상태가 아니라면
          console.log("setIsMethodRecalling true");
          store.commit('setIsMethodRecalling', true); // isMethodRecalling을 true로 변경(새로운 token을 갱신 및 저장 중인 상태)
          console.log('refresh_token', store.state.refresh_token)
          if (store.state.user_info.user_type === 'google') {
            axios
            .post('https://oauth2.googleapis.com/token', {
              // refresh token으로 새로운 access token 갱신
              client_id: process.env.VUE_APP_CLIENT_ID,
              client_secret: process.env.VUE_APP_CLIENT_SECRET,
              refresh_token: store.state.refresh_token,
              grant_type: 'refresh_token',
            })
            .then((res) => {
              // refresh_token이 만료되기 전이므로 정상적으로 access_token을 갱신
              console.log('refresh_token이 만료되기 전이므로 정상적으로 access_token을 갱신');
              console.log(res);
              http
              .get('account/update-token/', { headers: { Authorization: 'Bearer ' + res.data.access_token } }) // BE에 새로 갱신한 access token 정보 저장
              .then((res1) => {
                console.log('update-token res1', res1);
                console.log('BE에 새로 갱신한 access token 정보 저장');
                console.log('기존에 store에 저장된 access_token', store.state.access_token);
                // login 상태라면 (중간에 로그아웃 시 methodRecall 하지 않음)
                if (store.state.access_token) {
                  store.commit('setAccessToken', res.data.access_token); // store에 새로 갱신한 access token 저장
                  console.log('setIsMethodRecalling false');
                  store.commit('setIsMethodRecalling', false); // isMethodRecalling을 false로 변경(새로운 token을 갱신 및 저장 중이지 않은 상태)
                  setTimeout(() => {
                    resolve("access token 갱신 및 저장 완료 -> method 재호출 1");
                  }, 1000);
                }
              })
              .catch((err1) => {
                console.log("BE에 access token 저장 실패");
                console.log(err1);
                console.log(err1.response);
                setTimeout(() => {
                  reject(0); // BE에 access token 저장 실패
                }, 1);
              });
            })
            .catch((err) => {
              // refresh_token도 만료되어 사용자에게 재로그인 요청
              console.log("refresh token 만료(access token 갱신 실패)");
              console.log(err);
              console.log(err.response);
              setTimeout(() => {
                reject(1); // refresh token 만료(access token 갱신 실패)
              }, 1);
            });
          } else if (store.state.user_info.user_type === 'django' || store.state.user_info.user_type === 'django-prosecution') {
            http
            .get('account/update-token-recolumn/', { headers: { Authorization: 'Bearer ' + store.state.refresh_token } }) // BE에서 새로운 access token 받아오기
            .then(res => {
              console.log('update-token-recolumn res', res)
              // store.commit('setRefreshToken', res.data.refresh_token); // store에 새로 갱신한 refresh token 저장
              if (res.data.access_token) { // access token이 있다면(null이 아니라면)
                store.commit('setAccessToken', res.data.access_token); // store에 새로 갱신한 access token 저장
              }
              console.log("setIsMethodRecalling false");
              store.commit('setIsMethodRecalling', false); // isMethodRecalling을 false로 변경(새로운 token을 갱신 및 저장 중이지 않은 상태)
              setTimeout(() => {
                resolve("access token 갱신 및 저장 완료 -> method 재호출 2");
              }, 1000);
            })
            .catch((err) => {
              // refresh_token도 만료되어 사용자에게 재로그인 요청
              console.log("refresh token 만료(access token 갱신 실패)");
              console.log(err);
              console.log(err.response);
              setTimeout(() => {
                reject(1); // refresh token 만료(access token 갱신 실패)
              }, 1);
            });
          }
        } else {
          // methodRecall이 호출되고 새로운 token을 갱신 및 저장 중인 상태라면
          setTimeout(() => {
            resolve("access token 갱신 및 저장 완료 -> method 재호출 3");
            console.log("setIsMethodRecalling false");
            store.commit('setIsMethodRecalling', false);
          }, 1000);
        }
      });
    },

    transpose(original) { // 2차원 배열의 행, 열 변환
      if (!original || original.length === 0) return original
      const rowOfOrigin = original.length;
      const colOfOrigin = original[0].length;
      const transposed = Array.from({ length: colOfOrigin }, () => new Array(rowOfOrigin).fill(0));
      for(let i = 0; i < rowOfOrigin; i++) {
        for(let j = 0; j < colOfOrigin; j++) {
          [transposed[j][i]] = [original[i][j]];
        }
      }
      return transposed;
    },

    isAlpha(value) {
      return typeof value === "string" && value.length === 1 && (value >= "a" && value <= "z" || value >= "A" && value <= "Z");
    },

    excelToXY(cell) { // ex) A1 => (x: 0, y: 0)
      // 입력 문자열을 대문자로 변환
      cell = cell.toUpperCase();

      // 정규 표현식을 사용하여 셀 주소에서 열과 행을 분리합니다.
      const match = cell.match(/^([A-Z]+)(\d+)$/);
      if (!match) {
        throw new Error('Invalid cell address');
      }
    
      const col = match[1];
      const row = parseInt(match[2], 10);
    
      // 열을 숫자로 변환하는 함수
      let colNum = 0;
      for (let i = 0; i < col.length; i++) {
        colNum = colNum * 26 + (col.charCodeAt(i) - 'A'.charCodeAt(0) + 1);
      }
      
      // 0 기반 인덱스를 위해 1을 뺍니다.
      colNum -= 1;
    
      // 행 번호도 0 기반 인덱스를 위해 1을 뺍니다.
      const rowNum = row - 1;
    
      return { x: colNum, y: rowNum };
    },

    colAlphaToIdx(alpha) { // 열을 숫자로 변환하는 함수
      let colNum = 0;
      for (let i = 0; i < alpha.length; i++) {
        colNum = colNum * 26 + (alpha.toUpperCase().charCodeAt(i) - 'A'.charCodeAt(0) + 1);
      }
      // 0 기반 인덱스를 위해 1을 뺍니다.
      colNum -= 1;
      return colNum
    },

    numberToExcelColumn(num) { // 숫자를 열로 변환하는 함수
      let column = '';
      num++;
      while (num > 0) {
        let remainder = (num - 1) % 26;
        column = String.fromCharCode(65 + remainder) + column;
        num = Math.floor((num - 1) / 26);
      }
      return column;
    },

    clickStop() {
      console.log('clickStop')
    },

    closeTutorial(e) {
      console.log('closeTutorial')
      e.preventDefault()
      store.commit('setTutorialStep', 0)
      store.commit('setRpaTutorialStep', 0)
      store.commit('setDataModeTutorialStep', 0)
    },

    dateFormatFilter(value) {
      if (!value) return ''
      let val = value.split('.')[0]
      let date = val.split('T')[0]
      let yyyy = date.split('-')[0]
      let mm1 = date.split('-')[1]
      let dd = date.split('-')[2]
      let result = yyyy + '-' + mm1 + '-' + dd
      return result
    },
    timeFormatFilter(value) {
      if (!value) return ''
      let val = value.split('.')[0]
      let time = val.split('T')[1]
      let hh = time.split(':')[0]
      let mm2 = time.split(':')[1]
      let ss = time.split(':')[2].slice(0, 2)
      let result = hh + ':' + mm2 + ':' + ss
      return result
    },
  },
});

// 전역 filter
Vue.filter('menuFilter', (value) => {
  if (!value) return ''
  if (value === 'dashboard') return '타임라인'
  if (value === 'data-management') return '데이터'
  if (value === 'process') return '프로세스'
  if (value === 'insight') return '인사이트'
  if (value === 'group-ocr') return 'OCR'
  if (value === 'ocr') return 'OCR'
  if (value === 'pdf-classification') return 'PDF 분류'
  if (value === 'ai-engine') return 'AI Agent'
  if (value === 'rpa') return 'RPA'
  if (value === 'rpa2') return '워크플로우'
  if (value === 'inner-db') return 'Inner DB'
  if (value === 'group-custom') return '커스텀'
  if (value === 'slicer') return '슬라이서'
  if (value === 'iros-search') return 'IROS 검색'
  if (value === 'mou-list') return 'MOU 리스트'
  if (value === 'corporate-sales-status') return '법인판매현황'
  if (value === 'group-text-analyze') return '텍스트 분석'
  if (value === 'extraction') return '정보 추출'
  if (value === 'keyword') return '키워드'
  if (value === 'summary') return '요약'
  if (value === 'scatter') return '텍스트 분석'
})
Vue.filter('fileSizeFilter', (value) => {
  let result = null
  if (!value) {
    result = 0 + 'byte'
  }
  else if (value > (1024*1024*1024)) {
    result = value / (1024*1024*1024)
    result = result.toFixed(1)
    result = result + 'GB'
  }
  else if (value > (1024*1024)) {
    result = value / (1024*1024)
    result = result.toFixed(1)
    result = result + 'MB'
  }
  else if (value > 1024) {
    result = value / 1024
    result = result.toFixed(1)
    result = result + 'KB'
  }
  else {
    result = value + 'byte'
  }
  return result
})
Vue.filter('datetimeFormatFilter', (value) => {
  if (!value) return ''
  let val = value.split('.')[0]
  let date = val.split('T')[0]
  let yyyy = date.split('-')[0]
  let mm1 = date.split('-')[1]
  let dd = date.split('-')[2]
  let time = val.split('T')[1]
  let hh = time.split(':')[0]
  let mm2 = time.split(':')[1]
  let ss = time.split(':')[2]
  let result = yyyy + '-' + mm1 + '-' + dd + ' ' + hh + ':' + mm2 + ':' + ss
  return result
})
Vue.filter('datetimeFormatFilter2', (value) => {
  if (!value) return ''
  let val = value.split('.')[0]
  let date = val.split('T')[0]
  let yyyy = date.split('-')[0]
  let mm1 = date.split('-')[1]
  let dd = date.split('-')[2]
  let time = val.split('T')[1]
  let hh = time.split(':')[0]
  let mm2 = time.split(':')[1]
  let ss = time.split(':')[2]
  let result = yyyy + '-' + mm1 + '-' + dd + ', ' + hh + ':' + mm2 + ':' + ss
  return result
})
Vue.filter('dateFormatFilter', (value) => {
  if (!value) return ''
  let val = value.split('.')[0]
  let date = val.split('T')[0]
  let yyyy = date.split('-')[0]
  let mm1 = date.split('-')[1]
  let dd = date.split('-')[2]
  let result = yyyy + '-' + mm1 + '-' + dd
  return result
})
Vue.filter('dateFormatFilter2', (value) => {
  if (!value) return ''
  let val = value.split('.')[0]
  let date = val.split('T')[0]
  let yy = date.split('-')[0].slice(-2)
  let mm1 = date.split('-')[1]
  let dd = date.split('-')[2]
  let result = yy + '-' + mm1 + '-' + dd
  return result
})
Vue.filter('dateFormatFilterKor', (value) => {
  if (!value) return ''
  let val = value.split('.')[0]
  let date = val.split('T')[0]
  let yyyy = date.split('-')[0]
  let mm1 = date.split('-')[1]
  let dd = date.split('-')[2]
  let result = yyyy + '년' + mm1 + '월' + dd + '일'
  return result
})
Vue.filter('dateFormatFilterDot', (value) => {
  if (!value) return ''
  let val = value.split('.')[0]
  let date = val.split('T')[0]
  let yyyy = date.split('-')[0]
  let mm1 = date.split('-')[1]
  let dd = date.split('-')[2]
  let result = yyyy + '.' + mm1 + '.' + dd
  return result
})
Vue.filter('timeFormatFilter', (value) => {
  if (!value) return ''
  let val = value.split('.')[0]
  let time = val.split('T')[1]
  let hh = time.split(':')[0]
  let mm2 = time.split(':')[1]
  let ss = time.split(':')[2].slice(0, 2)
  let result = hh + ':' + mm2 + ':' + ss
  return result
})
Vue.filter('projectMembersFilter', (value) => {
  let result = 0
  if (value.members) result += value.members.length
  if (value.member_organizations) result += value.member_organizations.length
  return result
})
Vue.filter('organizationFilter', (value) => {
  let result = ''
  if (value === 'company') {
    result = '기업회원'
  } else {
    result = '개인회원'
  }
  return result
})
Vue.filter('dataCategoryFilter', (value) => {
  let result = ''
  if (!value.category) result = ''
  if (value.category === 'file') {
    if (!value.file) return '파일'
    if (value.file.includes('xls')) result = '엑셀 파일'
    else if (value.file.includes('csv')) result = 'CSV 파일'
    if (value.file.includes('jpg') || value.file.includes('jpeg') || value.file.includes('png')) result = '이미지 파일'
    if (value.file.includes('pdf')) result = 'PDF 파일'
    if (value.file.includes('json')) result = 'JSON 파일'
  }
  if (value.category === 'common') result = '일반'
  if (value.category === 'rpa') result = '워크플로우 결과'
  if (value.category === 'text_ie') result = 'PDF 분류 결과'
  return result
})
Vue.filter('columnHeaderFilter', (num) => {
  if (num == null) return ''
  let column = '';
  num++;
  while (num > 0) {
    let remainder = (num - 1) % 26;
    column = String.fromCharCode(65 + remainder) + column;
    num = Math.floor((num - 1) / 26);
  }
  return column;
})
Vue.filter('columnListFilter', (value) => {
  if (value == [] || !value) return ''
  return value.filter(v => v !== null && v !== undefined).map(num => {
    let column = '';
    num++;
    while (num > 0) {
      let remainder = (num - 1) % 26;
      column = String.fromCharCode(65 + remainder) + column;
      num = Math.floor((num - 1) / 26);
    }
    return column;
  }).join(', ')
})
Vue.filter('orderFuncFilter', (value) => {
  let result = ''
  if (value === 'AtoZ') result = '오름차순'
  else if (value === 'ZtoA') result = '내림차순'
  return result
})
Vue.filter('orderValFilter', (value) => {
  let result = ''
  if (value === 'number') result = '숫자'
  else if (value === 'currency') result = '통화'
  else if (value === 'date') result = '날짜'
  else result = '글자'
  return result
})
Vue.filter('orderFormat2Filter', (value) => {
  let result = ''
  if (value === 'comma') result = '1,000'
  else if (value === 'krw_end' || value === 'currency_krw_end') result = '1000원'
  else if (value === 'krw' || value === 'currency_krw') result = '￦1000'
  else if (value === 'usd' || value === 'currency_usd') result = '$1000'
  else if (value === 'eur' || value === 'currency_yen') result = '€1000'
  else if (value === 'gbp' || value === 'currency_eur') result = '£1000'
  else if (value === 'jpy' || value === 'currency_gbp') result = '￥1000'

  else if (value === '%Y/%m/%d' || value === 'yyyy/mm/dd') result = 'yyyy/mm/dd'
  else if (value === '%y/%m/%d' || value === 'yy/mm/dd') result = 'yy/mm/dd'
  else if (value === '%m/%d/%Y' || value === 'mm/dd/yyyy') result = 'mm/dd/yyyy'
  else if (value === '%m/%d/%y' || value === 'mm/dd/yy') result = 'mm/dd/yy'
  else if (value === '%d/%m/%Y' || value === 'dd/mm/yyyy') result = 'dd/mm/yyyy'
  else if (value === '%d/%m/%y' || value === 'dd/mm/yy') result = 'dd/mm/yy'
  else if (value === '%Y-%m-%d' || value === 'yyyy-mm-dd') result = 'yyyy-mm-dd'
  else if (value === '%y-%m-%d' || value === 'yy-mm-dd') result = 'yy-mm-dd'
  else if (value === '%m-%d-%Y' || value === 'mm-dd-yyyy') result = 'mm-dd-yyyy'
  else if (value === '%m-%d-%y' || value === 'mm-dd-yy') result = 'mm-dd-yy'
  else if (value === '%d-%m-%Y' || value === 'dd-mm-yyyy') result = 'dd-mm-yyyy'
  else if (value === '%d-%m-%y' || value === 'dd-mm-yy') result = 'dd-mm-yy'

  else result = ''
  return result
})
Vue.filter('filteredColumnTypeFilter', (value) => {
  let result = ''
  if ((value.func_type+'-'+value.func) === 'common-Null') result = '비어 있음'
  else if ((value.func_type+'-'+value.func) === 'common-notNull') result = '비어 있지 않음'

  else if ((value.func_type+'-'+value.func) === 'text-Contains') result = '텍스트에 포함(입력)'
  else if ((value.func_type+'-'+value.func) === 'text-notContains') result = '텍스트에 포함되지 않음(입력)'
  else if ((value.func_type+'-'+value.func) === 'file-Contains') result = '텍스트에 포함(가져오기)'
  else if ((value.func_type+'-'+value.func) === 'file-notContains') result = '텍스트에 포함되지 않음(가져오기)'
  else if ((value.func_type+'-'+value.func) === 'text-Equal') result = '텍스트가 정확하게 일치함(입력)'
  else if ((value.func_type+'-'+value.func) === 'text-notEqual') result = '텍스트가 정확하게 일치하지 않음(입력)'
  else if ((value.func_type+'-'+value.func) === 'file-Equal') result = '텍스트가 정확하게 일치함(가져오기)'
  else if ((value.func_type+'-'+value.func) === 'file-notEqual') result = '텍스트가 정확하게 일치하지 않음(가져오기)'
  else if ((value.func_type+'-'+value.func) === 'text-Startswith') result = '시작 텍스트:'
  else if ((value.func_type+'-'+value.func) === 'text-Endswith') result = '종료 텍스트:'
  else if ((value.func_type+'-'+value.func) === 'text-length') result = '글자 수(공백 포함)'
  else if ((value.func_type+'-'+value.func) === 'text-length_wo_blank') result = '글자 수(공백 미포함)'

  else if ((value.func_type+'-'+value.func) === 'number-Over') result = '초과(숫자)'
  else if ((value.func_type+'-'+value.func) === 'number-More') result = '보다 크거나 같음(숫자)'
  else if ((value.func_type+'-'+value.func) === 'number-Under') result = '미만(숫자)'
  else if ((value.func_type+'-'+value.func) === 'number-Less') result = '보다 작거나 같음(숫자)'
  else if ((value.func_type+'-'+value.func) === 'number-Equal') result = '같음(숫자)'
  else if ((value.func_type+'-'+value.func) === 'number-notEqual') result = '같지 않음(숫자)'
  else if ((value.func_type+'-'+value.func) === 'number-Range') result = '범위(숫자)'
  else if ((value.func_type+'-'+value.func) === 'number-notRange') result = '사이에 있지 않음(숫자)'

  else if ((value.func_type+'-'+value.func) === 'currency-Over') result = '초과(통화)'
  else if ((value.func_type+'-'+value.func) === 'currency-More') result = '보다 크거나 같음(통화)'
  else if ((value.func_type+'-'+value.func) === 'currency-Under') result = '미만(통화)'
  else if ((value.func_type+'-'+value.func) === 'currency-Less') result = '보다 작거나 같음(통화)'
  else if ((value.func_type+'-'+value.func) === 'currency-Equal') result = '같음(통화)'
  else if ((value.func_type+'-'+value.func) === 'currency-notEqual') result = '같지 않음(통화)'
  else if ((value.func_type+'-'+value.func) === 'currency-Range') result = '범위(통화)'
  else if ((value.func_type+'-'+value.func) === 'currency-notRange') result = '사이에 있지 않음(통화)'

  else if ((value.func_type+'-'+value.func) === 'date-year') result = '연도별'
  else if ((value.func_type+'-'+value.func) === 'date-month') result = '월별'
  else if ((value.func_type+'-'+value.func) === 'date-day') result = '일별'
  else if ((value.func_type+'-'+value.func) === 'date-today') result = '오늘'
  else if ((value.func_type+'-'+value.func) === 'date-this_month') result = '이번 달'
  else if ((value.func_type+'-'+value.func) === 'date-this_quarter') result = '이번 분기'
  else if ((value.func_type+'-'+value.func) === 'date-this_year') result = '올해'
  else if ((value.func_type+'-'+value.func) === 'date-Equal') result = '날짜'
  else if ((value.func_type+'-'+value.func) === 'date-Before') result = '기준일 이전'
  else if ((value.func_type+'-'+value.func) === 'date-After') result = '기준일 이후'
  else if ((value.func_type+'-'+value.func) === 'date-Range') result = '기준일 사이'
  else if ((value.func_type+'-'+value.func) === 'date-notRange') result = '기준일 사이에 있지 않음'
  return result
})
Vue.filter('separatorFilter', (value) => {
  if (value === '') return '없음'
  if (value === ' ') return '공백'
  if (value === '/') return '/ (슬래시)'
  if (value === '-') return '- (대시)'
})
Vue.filter('separatorListFilter', (value) => {
  if (!value || value.length === 0) return '없음'
  let result = []
  result = value.map(v => {
    if (v === ' ') return '공백'
    if (v === '/') return '/ (슬래시)'
    if (v === '-') return '- (대시)'
  })
  return result.join(', ')
})
Vue.filter('joinTypeFilter', (value) => {
  if (value === null || value < 0) return ''
  if (value === 'full_outer') return 'Full'
  if (value === 'inner') return 'Inner'
  if (value === 'left_outer') return 'Left'
  if (value === 'right_outer') return 'Right'
})
Vue.filter('logTypeFilter', (value) => {
  if (value === null || value < 0) return ''
  if (value === 'full_outer') return 'Full Outer Join'
  if (value === 'inner') return 'Inner Join'
  if (value === 'left_outer') return 'Left Outer Join'
  if (value === 'right_outer') return 'Right Outer Join'
  if (value === 'union') return 'Union'
  if (value === 'select') return 'Select'
  if (value === 'aggregation') return 'Aggregate'
  if (value === 'col2row') return 'Col2Row'
  if (value === 'mergeOCR') return 'OCR 병합'
  if (value === 'replace') return 'Replace'
  if (value === 'relocate') return 'Relocate'
  if (value === 'CopyToOther') return 'To Ocr'
  if (value === 'MakeFilteredItem') return 'Table Filter'
  if (value === 'pivot') return 'Pivot'
  if (value === 'AddTablesFromItem') return 'Import'
})
Vue.filter('replaceRuleFilter', (value) => {
  if (!value) return ''
  let result = ''
  if (value.type === 'substitution') {
    result = `변환('${value.option[0]}' -> '${value.option[1]}')`
  } else if (value.type === 'masking') {
    result = '익명화'
  }
  return result
})
Vue.filter('asyncTaskTypeIconFilter', (value) => {
  let result = ''
  if (value === 'project') result = 'mdi-content-copy'
  if (value === 'crawler') result = 'mdi-magnify'
  if (value === 'rpa') result = 'mdi-play-circle-outline'
  if (value === 'text-ie') result = 'mdi-file-search-outline'
  if (value === 'iros') result = ''
  if (value === 'data') result = 'mdi-database-outline'
  return result
})
Vue.filter('asyncTaskTypeFilter', (value) => {
  let result = value
  if (value === 'crawler') result = 'Crawler'
  if (value === 'rpa') result = 'Workflow'
  if (value === 'text-ie') result = 'PDF 분류'
  if (value === 'iros') result = 'IROS'
  if (value === 'data') result = '파일'
  return result
})
Vue.filter('asyncTaskStatusListPanelStatusFilter', (value) => {
  let result = ''
  if (value.task_type === 'project') {
    result = '프로젝트'
    if (value.status === 'Running') result += ' 복사 중...'
    if (value.status === 'Finished') result += ' 복사 완료'
    if (value.status === 'Idle') result += ' 복사 정지됨'
    if (value.status === 'Waiting') result += ' 복사 대기중'
    if (value.status?.includes('Initial')) result += ' 복사 준비중'
    if (value.status?.includes('Error') || value.status?.includes('Fail')) result += ' 복사 오류 발생'
  }
  if (value.task_type === 'crawler') {
    result = '크롤러'
    if (value.status === 'Running') result += ' 실행중...'
    if (value.status === 'Finished') result += ' 실행 완료'
    if (value.status === 'Idle') result += ' 정지됨'
    if (value.status === 'Waiting') result += ' 대기중'
    if (value.status?.includes('Initial')) result += ' 준비중'
    if (value.status?.includes('Error') || value.status?.includes('Fail')) result += ' 오류 발생'
  }
  if (value.task_type === 'rpa') {
    result = '워크플로우'
    if (value.status === 'Running') result += ' 실행중...'
    if (value.status === 'Finished') result += ' 실행 완료'
    if (value.status === 'Idle') result += ' 정지됨'
    if (value.status === 'Waiting') result += ' 대기중'
    if (value.status?.includes('Initial')) result += ' 준비중'
    if (value.status?.includes('Error') || value.status?.includes('Fail')) result += ' 오류 발생'
  }
  if (value.task_type === 'text-ie') {
    result = 'PDF 분류'
    if (value.status === 'Running') result += ' 실행중...'
    if (value.status === 'Finished') result += ' 실행 완료'
    if (value.status === 'Idle') result += ' 정지됨'
    if (value.status === 'Waiting') result += ' 대기중'
    if (value.status?.includes('Initial')) result += ' 준비중'
    if (value.status?.includes('Error') || value.status?.includes('Fail')) result += ' 오류 발생'
  }
  if (value.task_type === 'iros') {
    result = 'IROS'
    if (value.status === 'Running') result += ' 실행중...'
    if (value.status === 'Finished') result += ' 실행 완료'
    if (value.status === 'Idle') result += ' 정지됨'
    if (value.status === 'Waiting') result += ' 대기중'
    if (value.status?.includes('Initial')) result += ' 준비중'
    if (value.status?.includes('Error') || value.status?.includes('Fail')) result += ' 오류 발생'
  }
  if (value.task_type === 'data') {
    result = '파일 업로드'
    if (value.status === 'Running') result += ' 중...'
    if (value.status === 'Finished') result += ' 완료'
    if (value.status === 'Idle') result += ' 정지됨'
    if (value.status === 'Waiting') result += ' 대기중'
    if (value.status?.includes('Initial')) result += ' 준비중'
    if (value.status?.includes('Error') || value.status?.includes('Fail')) result += ' 오류 발생'
  }
  return result
})
Vue.filter('scheduleFrequencyFilter', (value) => {
  // value = "* * * * *" (분 시 일 월 요일)
  if (!value) return ''

  let arr = value.split(' ')
  if (arr.length < 5) return ''

  let minute = arr[0]
  let hour = arr[1]
  let date = arr[2]
  let month = arr[3]
  let day = arr[4]
  
  let month_text = ''
  if (month === '*') { // 매달 선택
    month_text = '매달'
  }
  else { // 월 선택창에서 직접 선택 => month = '1,2,3 ...'
    let month_arr = day.split(',')
    month_text = month_arr.join(', ') + '월'
  }

  let date_text = ''
  if (date === '*') { // 매일 선택
    date_text = '매일'
  }
  else { // 특정 일자 입력 - ex) 3일에 => date = '3'
    date_text = date + '일에'
  }
  if (day !== '*') { // 요일 선택창에서 요일 선택 - ex) 월요일, 화요일... => day = '1,2 ...'
    let day_arr = day.split(',')
    day_arr = day_arr.map(v => {
      if (v === 1) v = '월'
      if (v === 2) v = '화'
      if (v === 3) v = '수'
      if (v === 4) v = '목'
      if (v === 5) v = '금'
      if (v === 6) v = '토'
      if (v === 7) v = '일'
      return v
    })
    date_text = day_arr.join(', ') + '요일'
  }

  let time_text = ''
  if (hour[0] === '/') { // 반복할 시간 입력 - ex) 12시간 마다 => hour = '/12'
    time_text = hour.slice(1) + '시간마다'
  }
  else if (minute[0] === '/') { // 반복할 분 입력 - ex) 30분 마다 => minute = '/30'
    time_text = minute.slice(1) + '분마다'
  }
  else if (hour !== '*' && minute !== '*') { // 특정 시간 입력 - ex) 16:00에 실행 => hour = '16, minute = '0'
    if (minute.length === 1) {
      minute = '0' + minute
    }
    time_text += hour + ':' + minute + '에'
  }

  let result = month_text + ' / ' + date_text + ' / ' + time_text + '실행'
  return result
})
Vue.filter('asyncTaskStatusFilter', (value) => {
  let result = value
  if (value === 'Idle') result = '정지됨'
  if (value === 'Waiting') result = '대기중'
  if (value.includes('Initial')) result = '준비중'
  if (value === 'Running') result = '실행중'
  if (value === 'Finished') result = '종료됨'
  if (value.includes('Error') || value.includes('Fail')) result = '오류'
  return result
})
Vue.filter('historyTypeFilter', (value) => {
  let target = value.target_db
  let result_target = target
  if (target === 'TaskItem') result_target = '프로젝트'
  if (target === 'multiTableData') result_target = '파일'
  if (target === 'AsyncTaskStatusDB') result_target = '비동기 작업'
  if (target === 'RPAitem') result_target = '워크플로우'
  if (target === 'RpaRuleDB') result_target = '워크플로우 Rule'
  if (target === 'TerminologyDB') result_target = '언어 테이블'
  if (target === 'Ocr') result_target = 'OCR'
  if (target === 'mergeOCR') result_target = 'OCR 병합'
  if (target === 'Tag') result_target = '태그'
  if (target === 'InsightDB') result_target = '인사이트'
  if (target === 'TextIeRule') result_target = 'PDF 분류 Rule'
  return result_target
})
Vue.filter('historyActionFilter', (value) => {
  let action = value.msg
  let result_action = action
  if (action === 'upload') result_action = '업로드'
  if (action === 'create') result_action = '생성'
  if (action === 'update') result_action = '수정'
  if (action === 'delete') result_action = '삭제'
  if (action === 'run') result_action = '실행'
  if (action === 'ocr') result_action = '실행'
  if (action === 'share') result_action = '공유'
  return result_action
})
Vue.filter('historyTimeFilter', (value) => {
  let result = ''
  if (!value) return result
  const date = dayjs(value.created_at)
  const today = dayjs()
  const formattedTime = date.format("A h:mm:ss")

  if (date.isSame(today, "day")) {
    result = `오늘 ${formattedTime}`
  } else if (date.isYesterday()) {
    result = `어제 ${formattedTime}`
  } else {
    result = date.fromNow()
  }
  return result
})
Vue.filter('paidExpireDateFilter', (value) => {
  let result = ''
  if (!value) return result
  result = dayjs(value).add(7, 'day').format('MM/DD')
  return result
})
Vue.filter('datetimeFilter1', (value) => {
  if (!value) return ''
  let val = value.split('.')[0]
  let date = val.split('T')[0]
  let yyyy = date.split('-')[0]
  let mm1 = date.split('-')[1]
  let dd = date.split('-')[2]
  let time = val.split('T')[1]
  let hh = time.split(':')[0]
  let mm2 = time.split(':')[1]
  let ss = time.split(':')[2].slice(0, 2)
  let result = yyyy + '-' + mm1 + '-' + dd + ' ' + hh + ':' + mm2 + ':' + ss
  return result
})
Vue.filter('datetimeFilter2', (value) => {
  if (!value) return ''
  let val = value.split('.')[0]
  let date = val.split('T')[0]
  let yyyy = date.split('-')[0]
  let mm1 = date.split('-')[1]
  let dd = date.split('-')[2]
  let time = val.split('T')[1]
  let ampm = Number(time.split(':')[0]) >= 12 ? '오후' : '오전'
  let hh = Number(time.split(':')[0]) > 12 ? Number(time.split(':')[0]) - 12 : time.split(':')[0]
  let mm2 = time.split(':')[1]
  let ss = time.split(':')[2]
  // let result = yyyy + '-' + mm1 + '-' + dd + ' ' + hh + ':' + mm2 + ':' + ss
  // let result = hh+':'+mm2+' '+mm1+'월'+dd+'일'+' '+yyyy+'년'
  let result = `${yyyy}. ${mm1}. ${dd}. ${ampm} ${hh}:${mm2}:${ss}`
  return result
})
Vue.filter('workTypeFilter', (value) => {
  if (value === null) return ''
  else if (value === 0) return 'Join'
  else if (value === 1) return 'Union'
  else if (value === 2) return 'Select'
  else if (value === 3) return 'Aggregate'
  else if (value === 4) return 'OCR'
  else if (value === 5) return 'Col2Row'
  else if (value === 6) return 'Append'
  else if (value === 7) return 'OCR 병합'
  else if (value === 8) return 'Filter'
  else if (value === 9) return 'Replace'
  else if (value === 10) return 'AI matching'
  else if (value === 11) return 'Relocate'
  else if (value === 12) return 'To Ocr'
  else if (value === 13) return 'Table Filter'
})
Vue.filter('colTypeFilter', (value) => {
  if (value === null) return ''
  else if (value === 'text') return '텍스트'
  else if (value === 'number') return '숫자'
  else if (value === 'date') return '날짜'
  else if (value === 'currency') return '통화'
})
Vue.filter('colTypeIconFilter', (value) => {
  if (value === null) return ''
  else if (value === 'text') return 'mdi-format-text'
  else if (value === 'number') return 'mdi-numeric'
  else if (value === 'currency') return 'mdi-currency-krw'
  else if (value === 'date') return 'mdi-calendar-today'
})
Vue.filter('textIeRuleFunctionFilter', (value) => {
  if (value === null) return ''
  else if (value === 'text_exist') return '텍스트 포함'
})
Vue.filter('booleanToApplyFilter', (value) => {
  if (value) return '적용'
  else return '미적용'
})
Vue.filter('rangeUnitFilter', (value) => {
  if (!value) return ''
  else if (value === 'day') return '일'
  else if (value === 'week') return '주'
  else if (value === 'month') return '달'
})
Vue.filter('categorizeRangeDataListFilter', (value) => {
  if (!value || value.length === 0) return ''
  else {
    let result = ''
    value.forEach((obj, idx) => {
      if (idx < value.length-1) {
        result += `${obj.max} 이하 - ${obj.text}, `
      } else {
        result += `${obj.max} 이하 - ${obj.text}`
      }
    });
    return result
  }
})
Vue.filter('mouHistoryHeaderFilter', (value) => {
  if (!value) return ''
  if (value === 'id') return 'No.'
  if (value === 'user') return '유저'
  if (value === 'sales_type') return '판매유형'
  if (value === 'mou_doc') return '파일 1'
  if (value === 'business_registration') return '파일 2'
  if (value === 'contract_period') return '계약기간'
  if (value === 'company_name') return '법인명'
  if (value === 'registration_no') return '사업자등록번호'
  if (value === 'corporation_registration_no') return '법인등록번호'
  if (value === 'seal_certificate') return '인감증명서'
  if (value === 'car_registration_1') return '자동차등록증 1'
  if (value === 'car_registration_2') return '자동차등록증 2'
  if (value === 'status') return '상태'
  if (value === 'reject_note') return '반려 사유'
})
Vue.filter('dashBoardPeriodFilter', (value) => {
  if (!value) return ''
  else if (value === 'day') return '일'
  else if (value === 'week') return '주'
  else if (value === 'month') return '월'
})
Vue.filter('favoriteTypeFilter', (value) => {
  if (!value) return ''
  else if (value === 'TaskItem') return '프로젝트'
  else if (value === 'ProcessItem') return '프로세스'
  else if (value === 'RPAitem') return '워크플로우'
  else if (value === 'AsyncTaskStatusDB') return 'AI Agent'
  else if (value === 'multiTableData') return 'MTD'
})
Vue.filter('permissionFilter', (value) => {
  if (value === null || value === undefined) return ''
  else if (value === 4) return 'Owner'
  else if (value === 3) return 'Creator'
  else if (value === 2) return 'Creator'
  else if (value === 1) return 'Operator'
  else if (value === 0) return 'Viewer'
})
Vue.filter('organizationPermissionFilter', (value) => {
  if (!value) return ''
  else if (value === 'super_admin') return 'Super'
  else if (value === 'admin') return 'Admin'
  else if (value === 'normal') return 'Normal'
})
Vue.filter('dataCellFilter', (dataCell) => {
  if (
    dataCell.table_id === null || dataCell.table_id === undefined || 
    dataCell.col === null || dataCell.col === undefined || 
    dataCell.row === null || dataCell.row === undefined
  ) {
    return ''
  }

  let colAlpha = '';
  let _dataCell_col = JSON.parse(JSON.stringify(dataCell.col))
  _dataCell_col++;
  while (_dataCell_col > 0) {
    let remainder = (_dataCell_col - 1) % 26;
    colAlpha = String.fromCharCode(65 + remainder) + colAlpha;
    _dataCell_col = Math.floor((_dataCell_col - 1) / 26);
  }

  let _table_title = dataCell.table_title
  if (!_table_title) {
    _table_title = `시트 ${dataCell.table_id+1}`
  }

  return `${_table_title}, ${colAlpha}${dataCell.row+1}`
})
Vue.filter('dataRangeFilter', (dataRange) => {
  let startCell_colAlpha = ''
  if (dataRange.startCell && dataRange.startCell.col !== null && dataRange.startCell.col !== undefined) {
    let _dataRange_startCell_col = JSON.parse(JSON.stringify(dataRange.startCell.col))
    _dataRange_startCell_col++;
    while (_dataRange_startCell_col > 0) {
      let remainder = (_dataRange_startCell_col - 1) % 26;
      startCell_colAlpha = String.fromCharCode(65 + remainder) + startCell_colAlpha;
      _dataRange_startCell_col = Math.floor((_dataRange_startCell_col - 1) / 26);
    }
  }

  let endCell_colAlpha = ''
  if (dataRange.endCell && dataRange.endCell.col !== null && dataRange.endCell.col !== undefined) {
    let _dataRange_endCell_col = JSON.parse(JSON.stringify(dataRange.endCell.col))
    _dataRange_endCell_col++;
    while (_dataRange_endCell_col > 0) {
      let remainder = (_dataRange_endCell_col - 1) % 26;
      endCell_colAlpha = String.fromCharCode(65 + remainder) + endCell_colAlpha;
      _dataRange_endCell_col = Math.floor((_dataRange_endCell_col - 1) / 26);
    }
  }

  let _table_title = dataRange.table_title
  if (!_table_title) {
    _table_title = `시트 ${dataRange.table_id+1}`
  }

  return `${_table_title}, ${startCell_colAlpha}${dataRange.startCell.row+1}:${endCell_colAlpha}${dataRange.endCell.row+1}`
})
Vue.filter('categorizeDateFormatFromFilter', (value) => {
  if (!value) return ''
  let dateFormatFromList = [
    {text: 'yyyy-mm-dd', value: '%Y-%m-%d'},
    {text: 'yyyy/mm/dd', value: '%Y/%m/%d'},
    {text: 'yyyy.mm.dd', value: '%Y.%m.%d'},

    {text: 'yy-mm-dd', value: '%y-%m-%d'},
    {text: 'yy/mm/dd', value: '%y/%m/%d'},
    {text: 'yy.mm.dd', value: '%y.%m.%d'},

    {text: 'yyyy-mm', value: '%Y-%m'},
    {text: 'yyyy/mm', value: '%Y/%m'},
    {text: 'yyyy.mm', value: '%Y.%m'},

    {text: 'yy-mm', value: '%y-%m'},
    {text: 'yy/mm', value: '%y/%m'},
    {text: 'yy.mm', value: '%y.%m'},

    {text: 'mm-dd', value: '%m-%d'},
    {text: 'mm/dd', value: '%m/%d'},
    {text: 'mm.dd', value: '%m.%d'},
  ]
  let result = ''
  if (dateFormatFromList.filter(v => v.value === value).length > 0) {
    result = dateFormatFromList.filter(v => v.value === value)[0].text
  }
  return result
})
Vue.filter('categorizeDateFormatToFilter', (value) => {
  if (!value) return ''
  let dateFormatToList = [
    {text: 'yyyy', value: '4year'},
    {text: 'yy', value: '2year'},
    {text: 'yyyy-H', value: '4year_half'},
    {text: 'yy-H', value: '2year_half'},
    {text: 'yyyy-Q', value: '4year_quarter'},
    {text: 'yy-Q', value: '2year_quarter'},
    {text: 'Q', value: 'quarter'},
    {text: 'yyyy-mm', value: '4year_month'},
    {text: 'yy-mm', value: '2year_month'},
    {text: 'mm', value: 'month'},
  ]
  let result = ''
  if (dateFormatToList.filter(v => v.value === value).length > 0) {
    result = dateFormatToList.filter(v => v.value === value)[0].text
  }
  return result
})
Vue.filter('replaceTypeFilter', (value) => {
  if (!value || !value.type) return ''
  let result = ''
  if (value.type === 'keep') result = '일부 남기기'
  if (value.type === 'substitution') result = '바꾸기'
  if (value.type === 'masking') {
    result = '익명화'
    if (value.option && value.option.length > 0) {
      if (value.option[0] === 'name') result = '이름 익명화'
      if (value.option[0] === 'name_center') result = '중간 익명화'
    }
  }
  if (value.type === 'trim') result = '앞뒤/연속 공백 제거'
  return result
})
Vue.filter('capitalizeFirst', (value) => {
  if (!value) return ''
  let result = value.charAt(0).toUpperCase() + value.slice(1)
  return result
})
Vue.filter('widgetTypeFilter', (value) => {
  if (value === null || value < 0) return ''
  if (value === 'text') return '텍스트'
  if (value === 'number_chip') return '숫자 카드'
  if (value === 'bar_chart') return '막대 차트'
  if (value === 'vertical_stack_bar_chart') return '세로형 스택 차트'
  if (value === 'vertical_group_stack_bar_chart') return '세로형 그룹 스택 차트'
  if (value === 'horizontal_stack_bar_chart') return '가로형 스택 차트'
  if (value === 'horizontal_group_stack_bar_chart') return '가로형 그룹 스택 차트'
  if (value === 'line_chart') return '꺾은선 차트'
  if (value === 'donut_chart') return '도넛 차트'
  if (value === 'data_table') return '데이터 테이블'
})
Vue.filter('startCellFilter', (cleaningRule) => {
  let startCell_colAlpha = ''
  if (cleaningRule.startY !== null && cleaningRule.startY !== undefined) {
    let _cleaningRule_startY = JSON.parse(JSON.stringify(cleaningRule.startY))
    _cleaningRule_startY++;
    while (_cleaningRule_startY > 0) {
      let remainder = (_cleaningRule_startY - 1) % 26;
      startCell_colAlpha = String.fromCharCode(65 + remainder) + startCell_colAlpha;
      _cleaningRule_startY = Math.floor((_cleaningRule_startY - 1) / 26);
    }
  }

  return `${startCell_colAlpha}${cleaningRule.startX+1}`
})
Vue.filter('endCellFilter', (cleaningRule) => {
  let endCell_colAlpha = ''
  if (cleaningRule.endY !== null && cleaningRule.endY !== undefined) {
    let _cleaningRule_endY = JSON.parse(JSON.stringify(cleaningRule.endY))
    _cleaningRule_endY++;
    while (_cleaningRule_endY > 0) {
      let remainder = (_cleaningRule_endY - 1) % 26;
      endCell_colAlpha = String.fromCharCode(65 + remainder) + endCell_colAlpha;
      _cleaningRule_endY = Math.floor((_cleaningRule_endY - 1) / 26);
    }
  }

  return `${endCell_colAlpha}${cleaningRule.endX+1}`
})
Vue.filter('datePrepBaseFilter', (value) => {
  if (!value) return ''
  if (value === 'today') return '오늘'
  if (value === 'this_month') return '이번 달'
  if (value === 'value') return '지정일'
  if (value === 'last_data') return '마지막 날짜'
})
Vue.filter('cleaningRuleFilter', (cleaningRule) => {
  let startCell_colAlpha = ''
  if (cleaningRule.startY !== null && cleaningRule.startY !== undefined) {
    let _cleaningRule_startY = JSON.parse(JSON.stringify(cleaningRule.startY))
    _cleaningRule_startY++;
    while (_cleaningRule_startY > 0) {
      let remainder = (_cleaningRule_startY - 1) % 26;
      startCell_colAlpha = String.fromCharCode(65 + remainder) + startCell_colAlpha;
      _cleaningRule_startY = Math.floor((_cleaningRule_startY - 1) / 26);
    }
  }

  let endCell_colAlpha = ''
  if (cleaningRule.endY !== null && cleaningRule.endY !== undefined) {
    let _cleaningRule_endY = JSON.parse(JSON.stringify(cleaningRule.endY))
    _cleaningRule_endY++;
    while (_cleaningRule_endY > 0) {
      let remainder = (_cleaningRule_endY - 1) % 26;
      endCell_colAlpha = String.fromCharCode(65 + remainder) + endCell_colAlpha;
      _cleaningRule_endY = Math.floor((_cleaningRule_endY - 1) / 26);
    }
  }

  return `${startCell_colAlpha}${cleaningRule.startX+1}:${endCell_colAlpha}${cleaningRule.endX+1}`
})
Vue.filter('totalRuleFilter', (totalRule) => {
  if (!totalRule) return ''
  let _function = ''
  if (totalRule.function === 'total') _function = '총계'
  if (totalRule.function === 'sub') _function = '소계'
  let _side = ''
  if (totalRule.side === 'top' || totalRule.side === 'bottom') _side = '행'
  if (totalRule.side === 'left' || totalRule.side === 'right') _side = '열'
  let column = ''
  if (totalRule.sub_sum_key !== null && totalRule.sub_sum_key !== undefined) {
    let _sub_sum_key = JSON.parse(JSON.stringify(totalRule.sub_sum_key))
    _sub_sum_key++;
    while (_sub_sum_key > 0) {
      let remainder = (_sub_sum_key - 1) % 26;
      column = String.fromCharCode(65 + remainder) + column;
      _sub_sum_key = Math.floor((_sub_sum_key - 1) / 26);
    }
  }
  let result = ''
  if (column) {
    result = `${_function} ${_side} 추가(${column})`
  } else {
    result = `${_function} ${_side} 추가`
  }
  return result
})
Vue.filter('unionParallelExceptColFilter', (value) => {
  if (value === null || value === undefined || !value) return '-'
  return Array.from({length: value}, (_, i) => i).map(num => {
    let column = '';
    num++;
    while (num > 0) {
      let remainder = (num - 1) % 26;
      column = String.fromCharCode(65 + remainder) + column;
      num = Math.floor((num - 1) / 26);
    }
    return column
  }).join(', ')
})
Vue.filter('processChipIconFilter', (value) => {
  if (!value) return ''
  else if (value === '알 수 없음') return 'mdi-help-circle-outline'
  else if (value === '수작업') return 'mdi-account'
  else if (value === '데이터 복사') return 'mdi-content-copy'
  else if (value === '데이터 합산') return 'mdi-function-variant'
  else if (value === 'Key 보유') return 'mdi-key-variant'
  else return 'mdi-refresh'
})
Vue.filter('fileTypeFilter', (value) => {
  if (!value) return ''
  else if (value.file.includes('xls') || value.file.includes('csv')) return 'Excel'
  else if (value.file.includes('jpg') || value.file.includes('jpeg') || value.file.includes('png')) return 'Image'
  else if (value.file.includes('pdf')) return 'PDF'
  else if (value.file.includes('json')) return 'JSON'
  else if (value.category === 'rpa' || value.data_type === 'result_file') return 'RPA'
  else return 'Common'
})
Vue.filter('rpaBlockTimeLogFilter', (value) => {
  if (!value || isNaN(value)) return '-'
  let result = Number(value)
  if (result >= 1) {
    result = result.toFixed(0)
  } else {
    result = result.toFixed(2)
  }
  return result
})
Vue.filter('selectedPermissionListFilter', (value) => {
  if (value === null || value === undefined) return ''
  let result = []
  if (value.includes(4)) result.push('Owner')
  if (value.includes(3)) result.push('Creator')
  if (value.includes(2)) result.push('Creator')
  if (value.includes(1)) result.push('Operator')
  if (value.includes(0)) result.push('Viewer')
  if (value.includes('all_option')) result = ['전체']
  return result.join(', ')
})
Vue.filter('numberWithCommas', (value) => {
  if (!value) return ''
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
})
Vue.filter('dataFunctionFilter', (value) => {
  if (value === null || value < 0) return ''
  if (value === 'full_outer') return 'Join'
  if (value === 'inner') return 'Join'
  if (value === 'left_outer') return 'Join'
  if (value === 'right_outer') return 'Join'
  if (value === 'union') return 'Union'
  if (value === 'union_all_sheet') return 'Union'
  if (value === 'union_drop_duplicates') return 'Union'
  if (value === 'union_parallel') return 'Union'
  if (value === 'select') return 'Select'
  if (value === 'smart_select') return 'SmartSelect'
  if (value === 'aggregate') return 'Aggregate'
  if (value === 'pivot') return 'Pivot'
  if (value === 'table_filter') return 'Table Filter'
  if (value === 'replace') return 'Replace'
  if (value === 'text_match') return 'Text Match'
  if (value === 'find_keyword') return 'Keyword'
  if (value === 'relocate') return 'Relocate'
  if (value === 'insert') return 'Insert'
  if (value === 'col2row') return 'Col2Row'
  if (value === 'date_prep') return 'Date Prep'
  if (value === 'date_pivot') return 'Date Pivot'
  if (value === 'template') return 'Template'
  if (value === 'total') return 'Total'
  if (value === 'unique') return 'Unique'
  if (value === 'imputation') return 'Imputation'
  if (value === 'cleaning') return 'Cleaning'
  if (value === 'delete') return 'Delete'
  if (value === 'db_align') return 'DB Align'
  if (value === 'header') return 'Header'
  if (value === 'style_copy') return 'Style Copy'
  if (value === '_style') return 'Style'
  if (value === 'style_merge') return 'Style Merge'
  if (value === 'style_merge_parallel') return 'Style Merge'
  if (value === 'merge_cell') return 'MergeCell'
  if (value === 'split_cell') return 'SplitCell'
  if (value === 'merge') return 'Merge'
  if (value === 'sheet_delete') return 'SheetDelete'
  if (value === 'sheet_split') return 'SheetSplit'
  if (value === 'rename') return 'Rename'
  if (value === 'find_sheet') return 'FindSheet'
  if (value === 'zipcode') return 'Zipcode'
  if (value === 'update') return 'Update'
  if (value === 'compare') return 'Compare'
  if (value === 'split') return 'Split'
})
Vue.filter('chartTypeFilter', (value) => {
  if (!value) return ''
  if (value === 'column_chart') return i18n.locale === 'ko' ? '막대 차트' : i18n.locale === 'en' ? 'Column Chart' : '막대 차트'
  if (value === 'bar_chart') return i18n.locale === 'ko' ? '바 차트' : i18n.locale === 'en' ? 'Bar Chart' : '바 차트'
  if (value === 'donut_chart') return i18n.locale === 'ko' ? '도넛 차트' : i18n.locale === 'en' ? 'Donut Chart' : '도넛 차트'
  if (value === 'pie_chart') return i18n.locale === 'ko' ? '파이 차트' : i18n.locale === 'en' ? 'Pie Chart' : '파이 차트'
  if (value === 'stacked_column_chart') return i18n.locale === 'ko' ? '세로형 스택 차트' : i18n.locale === 'en' ? 'Stacked Column Chart' : '세로형 스택 차트'
  if (value === 'stacked_bar_chart') return i18n.locale === 'ko' ? '가로형 스택 차트' : i18n.locale === 'en' ? 'Stacked Bar Chart' : '가로형 스택 차트'
  if (value === 'line_chart') return i18n.locale === 'ko' ? '꺾은선 차트' : i18n.locale === 'en' ? 'Line Chart' : '꺾은선 차트'
  if (value === 'mixed_chart') return i18n.locale === 'ko' ? '혼합 차트' : i18n.locale === 'en' ? 'Mixed Chart' : '혼합 차트'
  if (value === 'data_table') return i18n.locale === 'ko' ? '데이터 테이블' : i18n.locale === 'en' ? 'Data Table' : '데이터 테이블'
  if (value === 'number_chip') return i18n.locale === 'ko' ? '숫자 카드' : i18n.locale === 'en' ? 'Number Card' : '숫자 카드'
})
Vue.filter('dataFormatTitleFilter', (value) => {
  if (!value) return ''
  if (i18n.locale === 'ko') return value
  if (i18n.locale === 'en') {
    if (value === '기본') return 'General'
    else if (value === '백분율') return 'Percentage'
    else if (value === '증감율 계산') return 'Calculate % Change'
    else return value
  }
})
Vue.filter('formatOptionFilter', (value) => {
  if (value == null) return ''
  if (value === '') return i18n.locale === 'ko' ? '서식 없음' : i18n.locale === 'en' ? 'No Formatting' : '서식 없음'
  if (value === 'always') return i18n.locale === 'ko' ? '항상 표시' : i18n.locale === 'en' ? 'Always Show' : '항상 표시'
  if (value === 'over') return i18n.locale === 'ko' ? '초과' : i18n.locale === 'en' ? 'Greater Than' : '초과'
  if (value === 'more') return i18n.locale === 'ko' ? '보다 크거나 같음' : i18n.locale === 'en' ? 'Greater Than or Equal To' : '보다 크거나 같음'
  if (value === 'under') return i18n.locale === 'ko' ? '미만' : i18n.locale === 'en' ? 'Less Than' : '미만'
  if (value === 'less') return i18n.locale === 'ko' ? '보다 작거나 같음' : i18n.locale === 'en' ? 'Less Than or Equal To' : '보다 작거나 같음'
  if (value === 'equal') return i18n.locale === 'ko' ? '같음' : i18n.locale === 'en' ? 'Is Equal To' : '같음'
  if (value === 'notEqual') return i18n.locale === 'ko' ? '같지 않음' : i18n.locale === 'en' ? 'Is Not Equal To' : '같지 않음'
  if (value === 'range') return i18n.locale === 'ko' ? '사이에 있음' : i18n.locale === 'en' ? 'Is Between' : '사이에 있음'
  if (value === 'notRange') return i18n.locale === 'ko' ? '사이에 있지 않음' : i18n.locale === 'en' ? 'Is Not Between' : '사이에 있지 않음'
})
Vue.filter('filtersOptionFilter', (filter) => {
  let result = '없음'
  // 텍스트
  if (filter.type === 'text') {
    if (filter.op === 'empty') result = '비어 있음'
    else if (filter.op === 'notEmpty') result = '비어 있지 않음'
    else if (filter.op === 'contains') result = '포함'
    else if (filter.op === 'notContains') result = '포함되지 않음'
    else if (filter.op === 'eq') result = '일치함'
    else if (filter.op === 'neq') result = '일치하지 않음'
    else if (filter.op === 'startsWith') result = '시작 텍스트:'
    else if (filter.op === 'endsWith') result = '종료 텍스트:'
    else if (filter.op === 'lenWithSpace') result = '글자 수(공백 포함)'
    else if (filter.op === 'lenNoSpace') result = '글자 수(공백 미포함)'
  }
  // 숫자
  else if (filter.type === 'number') {
    if (filter.op === 'empty') result = '비어 있음'
    else if (filter.op === 'notEmpty') result = '비어 있지 않음'
    else if (filter.op === 'gt') result = '초과'
    else if (filter.op === 'gte') result = '보다 크거나 같음'
    else if (filter.op === 'lt') result = '미만'
    else if (filter.op === 'lte') result = '보다 작거나 같음'
    else if (filter.op === 'eq') result = '같음'
    else if (filter.op === 'neq') result = '같지 않음'
    else if (filter.op === 'between') result = '사이에 있음'
    else if (filter.op === 'notBetween') result = '사이에 있지 않음'
  }
  // 날짜
  else if (filter.type === 'date') {
    if (filter.op === 'empty') result = '비어 있음'
    else if (filter.op === 'notEmpty') result = '비어 있지 않음'
    else if (filter.op === 'year') result = '연도별'
    else if (filter.op === 'quarter') result = '분기별'
    else if (filter.op === 'month') result = '월별'
    else if (filter.op === 'day') result = '일별'
    else if (filter.op === 'today') result = '오늘'
    else if (filter.op === 'thisMonth') result = '이번 달'
    else if (filter.op === 'thisQuarter') result = '이번 분기'
    else if (filter.op === 'thisYear') result = '올해'
    else if (filter.op === 'on') result = '기준일'
    else if (filter.op === 'before') result = '기준일 이전'
    else if (filter.op === 'after') result = '기준일 이후'
    else if (filter.op === 'between') result = '기준일 사이'
    else if (filter.op === 'notBetween') result = '기준일 사이에 있지 않음'
  }
  return result
})
Vue.filter('findSheerRuleFilter', (rule_item) => {
  if (!rule_item) return ''
  let result = ''
  if (rule_item.format === 'text') {
    let rule_function = ''
    if (rule_item.function === 'Contains') rule_function = '포함'
    if (rule_item.function === 'notContains') rule_function = '포함되지 않음'
    if (rule_item.function === 'Equal') rule_function = '일치함'
    if (rule_item.function === 'notEqual') rule_function = '일치하지 않음'
    if (rule_item.function === 'Startswith') rule_function = '시작 텍스트:'
    if (rule_item.function === 'Endswith') rule_function = '종료 텍스트:'
    result = '텍스트' + ',' + rule_function + ',' + rule_item.input_1
    if (rule_item.input_2) result += rule_item.input_2
  }
  if (rule_item.format === 'date') {
    let rule_function = ''
    if (rule_item.function === 'year') rule_function = '연도별'
    if (rule_item.function === 'quarter') rule_function = '분기별'
    if (rule_item.function === 'month') rule_function = '월별'
    if (rule_item.function === 'day') rule_function = '일별'
    if (rule_item.function === 'today') rule_function = '오늘'
    if (rule_item.function === 'this_month') rule_function = '이번 달'
    if (rule_item.function === 'this_quarter') rule_function = '이번 분기'
    if (rule_item.function === 'this_year') rule_function = '올해'
    if (rule_item.function === 'Equal') rule_function = '기준일'
    if (rule_item.function === 'Before') rule_function = '기준일 이전'
    if (rule_item.function === 'After') rule_function = '기준일 이후'
    if (rule_item.function === 'Range') rule_function = '기준일 사이'
    if (rule_item.function === 'notRange') rule_function = '기준일 사이에 있지 않음'
    result = '날짜' + ',' + rule_function + ',' + rule_item.input_1
    if (rule_item.input_2) result += rule_item.input_2
  }
  if (rule_item.format === 'index') {
    result = '시트 순서' + ',' + rule_item.index_arr.join(',')
  }
  return result
})

Vue.config.productionTip = false;
Vue.prototype.$axios = axios;

import TokenManager from './plugins/tokenManager';
// Vue.use(TokenManager, {
//   store,
//   refreshInterval: 1000 * 60 * 1, // 1분
// });

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
  created() {
    Vue.use(TokenManager, {
      store,
      refreshInterval: 1000 * 60 * 1, // 1분
    });
  },
}).$mount("#app");

// storage 이벤트 리스너 추가하여 상태 업데이트
window.addEventListener('storage', (event) => {
  console.log('add storage event', event)
  if (event.key === 'auth') {
    const newState = JSON.parse(event.newValue);
    console.log('newState', newState)
    store.replaceState(Object.assign(store.state, newState));
  }
});
